import { Autocomplete, Box, TextField, Chip, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

interface BuildersInputProps {
  options: string[];
  selectedFilter: string[];
  setSelectedFilter: React.Dispatch<React.SetStateAction<string[]>>;
}

const BuildersInput = ({
  options,
  selectedFilter,
  setSelectedFilter,
}: BuildersInputProps) => {
  return (
    <Box>
      <Autocomplete
        multiple
        options={options}
        value={selectedFilter}
        disableCloseOnSelect
        onChange={(_, value) => {
          setSelectedFilter(value);
        }}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option}
              size="small"
              {...getTagProps({ index })}
              key={option}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search and select..."
            InputProps={{
              ...params.InputProps,
              endAdornment: params.InputProps.endAdornment,
            }}
          />
        )}
      />
    </Box>
  );
};

export default BuildersInput;
